import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Row } from "@/libraries/wpl/foundations/src";

type TestimonialCardProps = {
    readonly image: string;
    readonly quote: string;
    readonly name: string;
    readonly title: string;
};

const imageContainerStyles = css({
    width: "100%",
    position: "relative",
    margin: "70px 0 46px 60x",
    textAlign: "right",
    [media.below.sm]: {
        textAlign: "center",
        margin: "30px 0 0"
    }
});

const customerImageStyles = css({
    width: "267px",

    [media.below.md]: {
        width: "200px"
    },
    [media.below.sm]: {
        width: "267px",
        margin: "0 30px 0 0"
    }
});

const quoteContainerStyles = css({
    "position": "relative",
    "margin": "62px 0",
    "width": "auto",
    "textAlign": "left",

    [media.below.sm]: {
        margin: "0 auto 20px auto"
    },
    // Tech debt: Adding this disable to unblock commits for GWP-2646
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "p, blockquote": {
        ["&.quote"]: {
            fontSize: "26px",
            fontWeight: 300,
            lingHeight: "32px",
            zIndex: "2",
            maxWidth: "667px",
            margin: "1em 0",
            [media.only.sm]: {
                width: "424px",
                fontSize: "24px",
                fontWeight: 300
            },
            [media.below.sm]: {
                width: "311px",
                fontSize: "20px",
                fontWeight: 300,
                lingHeight: "28px",
                margin: "0 0 25px 0"
            }
        },
        ["&.name"]: {
            fontSize: "16px",
            lineHeight: "0px",
            fontWeight: 700,
            margin: 0
        },
        ["&.title"]: {
            fontSize: ".875rem",
            lineHeight: "1rem",
            fontWeight: 400,
            textTransform: "uppercase"
        }
    }
});

export const TestimonialCard = ({
    image,
    quote,
    name,
    title
}: TestimonialCardProps) => {
    return (
        <Row layout="4-8">
            {getTestimonialCardImage(image)}
            <div css={quoteContainerStyles}>
                <blockquote className="quote">“{quote}”</blockquote>
                <p className="name">{name}</p>
                <p className="title">{title}</p>
            </div>
        </Row>
    );
};

export const getTestimonialCardImage = (image: string) => {
    return (
        <div css={imageContainerStyles}>
            {/* eslint-disable-next-line no-restricted-syntax */}
            <img css={customerImageStyles} src={image} alt={""} />
        </div>
    );
};
